




































































import { Component, Vue, Watch } from 'vue-property-decorator';
import { mapGetters } from 'vuex';
import userInterface from '../interface/user';
import taskInterface from '../interface/taskInterface';
import taskInfo from '../../store/user/taskInfo';
import playSound from '../../utils/sounds/index';

@Component({
  computed: {
    ...mapGetters(['getUsers', 'getCurrentName', 'getCompletedLength']),
  },
})
export default class PlayerSide extends Vue {
  getCurrentName!: string;

  getUsers!: userInterface[];

  taskInfo = taskInfo;

  playSound = playSound;

  @Watch('getCompletedLength') onLengthChange(): void {
    this.playSound('taskCompleted');
  }

  get currentUser(): userInterface | undefined {
    return this.getUsers.find((u) => u.name === this.getCurrentName);
  }

  get currentTasks(): taskInterface[] | undefined {
    return this.currentUser?.hand.currentTasks;
  }

  get completedTasks(): taskInterface[] | undefined {
    return this.currentUser?.hand.completedTasks;
  }

  get cardsInHand(): [string, number][] {
    const cards = this.currentUser?.hand.cards;
    if (!cards) return [];
    const arrayOfCards = Object.entries(cards);
    return arrayOfCards;
  }

  get currentColor(): string {
    const user = this.currentUser;
    return user ? user.color : '';
  }

  showRouteInfo(cities: string[]): void {
    this.$emit('showCities', cities);
  }

  hideRouteInfo(): void {
    this.$emit('hideCities');
  }

  takeCardPlaySound(): void {
    this.playSound('takeCard');
  }
}
